import cn from 'classnames/bind'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import * as styles from './index.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const cx = cn.bind(styles)

class Toggle extends PureComponent {
    static propTypes = {
        expanded: PropTypes.bool,
        isLeaf: PropTypes.bool,
        onNodeToggle: PropTypes.func,
        id: PropTypes.string,
    }

    onToggle = e => {
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
        this.props.onNodeToggle(this.props.id)
    }

    onKeyDown = e => {
        if (e.key === 'Enter' || e.keyCode === 32) {
            this.props.onNodeToggle(this.props.id)
            e.preventDefault()
        }
    }

    render() {
        const { expanded, isLeaf } = this.props
        if (isLeaf) return null

        const toggleCx = cx('toggle', { expanded, collapsed: !expanded })
        return (
            <FontAwesomeIcon className="multi-select-arrow svg-standard-color" icon={expanded ? "angle-down" : "angle-right" }
                role="button"
                tabIndex={-1}
                onClick={this.onToggle}
                onKeyDown={this.onKeyDown}
                aria-hidden />
        )
    }
}

export default Toggle
